import { FormTypes } from '../../../../components/FormGenerator';
import VenueRegistrationFormModal from '../../shared/VenueRegistrationFormModal';

class InsuranceDeclarationModal extends VenueRegistrationFormModal {
	constructor() {
		super({
			modalSelector: '#insurance-declaration-form-modal',
			triggerSelectors: ['.js-insurance-declaration-trigger'],
			editTriggerSelectors: ['.js-insurance-declaration-edit-trigger'],
			stepsEndpointAttr: 'insurance-declaration-steps-endpoint',
			submitEndpointAttr: 'insurance-declaration-submit-endpoint',
			wrapperSelector: '.p-venue-registration-insurance-info',
			sectionWrapperSelector: '.p-venue-registration-insurance-info-wrapper',
			logPrefix: 'InsuranceDeclarationModal'
		});
	}

	getFormGeneratorOptions() {
		return {
			totalSteps: 1,
			formType: FormTypes.SectionForm,
			radioAnswerField: 'value',
			exitButtonLabel: 'Save and exit',
			showExitWithoutSavingButton: true,
			exitWithoutSavingButtonLabel: 'Exit without saving',
			exitWithoutSavingButtonHandler: () => this.closeFormModal(),
			submitButton: {
				title: 'Save and continue',
				alwaysVisible: true
			}
		};
	}
}

VenueRegistrationFormModal.boot(InsuranceDeclarationModal);

export default InsuranceDeclarationModal;
